/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_EstimateInputs */

const en_filter_has_estimate = /** @type {(inputs: Filter_Has_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an estimate`)
};

const de_filter_has_estimate = /** @type {(inputs: Filter_Has_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzung`)
};

/**
* | output |
* | --- |
* | "an estimate" |
*
* @param {Filter_Has_EstimateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_estimate = /** @type {((inputs?: Filter_Has_EstimateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_EstimateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_estimate(inputs)
	return en_filter_has_estimate(inputs)
});